import { format, isDate } from 'date-fns';
import { ko } from 'date-fns/locale';

type DateForamt =
  | 'yyyy-MM-dd'
  | "yyyy-MM-dd'T'HH:mm:ss+0900"
  | 'L월 d일(EEEEEE) HH:mm:ss'
  | 'L월 d일 (EEEEEE)'
  | 'yy년 L월 d일(EEEEEE)'
  | 'yy년 M월'
  | 'yyyy-MM-dd HH:mm:ss'
  | 'yyyy. M. d'
  | 'yyyy.M.d(EEEEEE)'
  | 'M.d(EEEEEE)'
  | 'L월 d일'
  | 'dd(EEEEEE)';
export const formatDate = (date: Date | string, dateFormat: DateForamt, locale = ko) =>
  format(isDate(date) ? (date as Date) : new Date(date), dateFormat, { locale });

/**
 *
 * @param date
 * @returns 'M. d'
 * 사파리의 경우 Date 생성자에 '/'가 아니면 에러가 발생한다.
 * '-'를 '/'로 변경하여 생성자에 넣어준다.
 * https://stackoverflow.com/questions/4310953/invalid-date-in-safari
 */
export const dateFormatForSafari = (date: string) => format(new Date(date.replace(/. /g, '/')), 'M. d', { locale: ko });
